// extracted by mini-css-extract-plugin
module.exports = {"divider":"buttonsor_divider__2RFwH","small":"buttonsor_small__1t8OW","buttonsOrWrapper":"buttonsor_buttonsOrWrapper__11lEB"};